import React, { useState } from "react";
import '../../components/AccountManagement/Accounts.css';
import inputStyles from '../ManagementPages.module.css';
import { useSelector } from 'react-redux';
import { normalizeHeightToCm, buildHeightState, buildWeightState } from '../../utils/accountUtils';

const ActivateHealthInfo = ({userData, handleChange}) => {

    const dropdowns = useSelector((state) => state.dropdowns);
    const birthday = userData.healthInfo.dateOfBirth ? userData.healthInfo.dateOfBirth.substring(0,10) : "";
    const isMetric = userData.preferences.unitType === "Metric";

   //weight 
    const [weight, setWeight] = useState(() =>
        buildWeightState(isMetric, userData.healthInfo.weight)
    );

    // height 
    const [height, setHeight] = useState(() =>
        buildHeightState(isMetric, userData.healthInfo.height)
    );

    const handleWeightBlur = () => {
        if (weight === '' || /^\d+$/.test(weight)) {
            const numericValue = weight === '' ? 0 : Number(weight);
            let metricValue = numericValue;
            if (!isMetric) {
                // convert lb to kg
                metricValue = Number((metricValue * 0.45359237).toFixed(2));
            }
            handleChange(metricValue,"weight","healthInfo")
        }
    };

    const handleHeightBlur = () => {
        const metricHeight = normalizeHeightToCm(isMetric, height);
        if (metricHeight === null) {
            return;
        }
        handleChange(metricHeight, "height", "healthInfo");
    };

    const today = new Date().toLocaleDateString('fr-ca');

    const [count, setCount] = useState(userData.healthInfo.notes.length);
    const handleNotes = (e) => {
        setCount(e.target.value.length);
        handleChange(e,"notes","healthInfo")
    };


    return (
        <div className="personal-info-container">
            <div className="personal-info-content">
                <div className={inputStyles["styled-input-container"]}>
                    <span className="floating-label" >Date of Birth</span>
                    <input
                        defaultValue={birthday}
                        type="date"
                        max={today}
                        id="dateOfBirth"
                        style={{width:"300px"}}
                        onChange={handleChange}
                    ></input>
                </div>
                <div className="input-name" style={{color:"#5E5E5E",fontSize:"13px"}}>Height</div>
                {!isMetric ?
                    <div className="input-block" style={{width: "300px", marginBottom:"0"}}>
                        <div className={inputStyles["styled-input-container"]} style={{width:"49%"}}>
                            <input
                                style={{width:"100%"}}
                                id="feet"
                                min="0"
                                max="8"
                                type="number"
                                value={height.feet}
                                onChange={(e) => setHeight(prevUserData => ({
                                    ...prevUserData,
                                    "feet": e.target.value
                                }))}
                                onBlur={() => handleHeightBlur()}
                            ></input>
                            <label className={height.feet && inputStyles['filled']}>
                                ft
                            </label>
                        </div>
                        <div className={inputStyles["styled-input-container"]} style={{width:"49%"}}>
                            <input
                                style={{width:"100%"}}
                                id="inches"
                                type="number"
                                min="0"
                                max="11"
                                value={height.inches}
                                onChange={(e) => setHeight(prevUserData => ({
                                    ...prevUserData,
                                    "inches": e.target.value
                                }))}
                                onBlur={() => handleHeightBlur()}
                            ></input>
                            <label className={height.inches && inputStyles['filled']}>
                                in
                            </label>
                        </div>
                    </div>
                    :
                    <div className={inputStyles["styled-input-container"]} style={{width:"49%"}}>
                        <input
                            style={{width:"100%"}}
                            id="cm"
                            type="number"
                            min="0"
                            step="any"
                            value={height.cm}
                            onChange={(e) => setHeight(prevUserData => ({
                                ...prevUserData,
                                "cm": e.target.value
                            }))}
                            onBlur={() => handleHeightBlur()}
                        ></input>
                        <label className={height.cm && inputStyles['filled']}>
                            cm
                        </label>
                    </div>
                }
                <div className="input-name" style={{color:"#5E5E5E",fontSize:"13px"}}>Weight</div>
                <div className={inputStyles["styled-input-container"]}>
                    <input
                        style={{width:"150px"}}
                        id="weight"
                        step="any"
                        min="0"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        onBlur={() => handleWeightBlur()}
                    ></input>
                    <label className={weight && inputStyles['filled']}>
                        {isMetric ? "kg" : "lb"}
                    </label>
                </div>
                <div style={{position: "relative"}}>
                    <span className="floating-label">Gender</span>
                    <select
                        className={inputStyles["styled-input-select"]}
                        id="gender"
                        style={{width:"300px"}}
                        value={userData.healthInfo.gender}
                        onChange={(e)=>handleChange(e,"gender","healthInfo")}
                    >
                        <option value="">Select a Gender</option>
                        {dropdowns.gender.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </select>
                </div>
                <div style={{position: "relative"}}>
                    <span className="floating-label">Ethnicity</span>
                    <select
                        className={inputStyles["styled-input-select"]}
                        id="ethnicity"
                        style={{width:"300px"}}
                        value={userData.healthInfo.ethnicity}
                        onChange={(e)=>handleChange(e,"ethnicity","healthInfo")}
                    >
                        <option value="">Select Ethnicity</option>
                        {dropdowns.ethnicity.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </select>
                </div>
                {/* <div className={inputStyles["styled-input-container"]}>
                    <input
                        id="conditions"
                        style={{width:"300px"}}
                        value={userData.healthInfo.conditions}
                        onChange={(e)=>handleChange(e,null,"healthInfo")}
                    ></input>
                    <label className={userData.healthInfo.conditions && inputStyles['filled']}>
                        Condition
                    </label>
                </div> */}
                {/* <div style={{position: "relative"}}>
                    <span className="floating-label">Critical Level</span>
                    <select
                        className={inputStyles["styled-input-select"]}
                        id="criticalLevel"
                        style={{width:"300px"}}
                        value={userData.healthInfo.criticalLevel}
                        onChange={(e)=>handleChange(e,"criticalLevel","healthInfo")}
                    >
                        <option value="">Select Critical Level</option>
                        {dropdowns.criticalLevel.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </select>
                </div> */}
                {/* <div style={{position: "relative"}}>
                    <span className="floating-label">Phase</span>
                    <select
                        className={inputStyles["styled-input-select"]}
                        id="phase"
                        style={{width:"300px"}}
                        value={userData.healthInfo.phase}
                        onChange={(e)=>handleChange(e,"phase","healthInfo")}
                    >
                        <option value="">Select Phase</option>
                        {dropdowns.phases.values.map((type) => (
                            <option key={type.id} value={type.id}>
                                {type.display}
                            </option>
                        ))}
                    </select>
                </div> */}
                <div className={inputStyles["styled-input-container"]} style={{width:"300px"}}>
                    <textarea 
                        className={inputStyles["note-input"]}
                        id="notes"
                        style={{width:"300px"}}
                        type="text"
                        maxLength={250}
                        value={userData.healthInfo.notes}
                        onChange={e => handleNotes(e)}
                    >
                    </textarea>
                    <label className={userData.healthInfo.notes && inputStyles['filled']}>
                        Notes
                    </label>
                    <span style={{fontSize:"10px", color:"#929395", marginLeft:"auto"}}>
                        {count}/250
                    </span>
                </div>
            </div>
        </div>
    )

}

export default ActivateHealthInfo;